export const MOVEMENT_TYPES = [
  { value: 'in', label: 'Entrada', color: '#10b981' },
  { value: 'out', label: 'Saída', color: '#ef4444' },
  { value: 'adjustment', label: 'Ajuste', color: '#0D9488' },
  { value: 'return', label: 'Devolução', color: '#f59e0b' },
  { value: 'loss', label: 'Perda', color: '#dc2626' },
  { value: 'expired', label: 'Vencido', color: '#6b7280' },
  { value: 'transfer', label: 'Transferência', color: '#0D9488' },
];

export const MOTIVOS_ENTRADA = ['Compra', 'Doação', 'Transferência', 'Devolução de paciente', 'Bonificação', 'Ajuste de inventário', 'Outro'];

/** Motivos de saída — padrão Feegow */
export const MOTIVOS_SAIDA = [
  'Vencimento',
  'Estabilidade da Droga (Ultrapassou o período de utilização após aberto)',
  'Quebra/Desperdício',
  'Empréstimo externo',
  'Venda',
  'Brinde/Divulgação',
];

export const getMotivosForMovement = (movementType: string) => {
  if (movementType === 'in' || movementType === 'return') return MOTIVOS_ENTRADA;
  if (['out', 'loss', 'expired'].includes(movementType)) return MOTIVOS_SAIDA;
  return [...MOTIVOS_ENTRADA, ...MOTIVOS_SAIDA.filter((m) => !MOTIVOS_ENTRADA.includes(m))];
};

/* ── Eventos de perda tipados (Fase 2c) ─────────────────────────────── */

export const LOSS_EVENT_TYPES = [
  { value: 'breakage_waste', label: 'Quebra / desperdício' },
  { value: 'expiry', label: 'Vencimento' },
  { value: 'recall', label: 'Recall do fabricante' },
  { value: 'contamination', label: 'Contaminação / estabilidade' },
  { value: 'theft_loss', label: 'Extravio / furto' },
  { value: 'procedure_unused', label: 'Não utilizado no procedimento' },
  { value: 'return_supplier', label: 'Devolução ao fornecedor' },
  { value: 'complication', label: 'Complicação intraoperatória' },
  { value: 'other', label: 'Outro' },
];

export const CLINICAL_CONTEXT_TYPES = [
  { value: 'evolution', label: 'Evolução clínica' },
  { value: 'treatment_plan_item', label: 'Item do plano de tratamento' },
  { value: 'procedure_execution', label: 'Execução de procedimento' },
  { value: 'reservation', label: 'Reserva de estoque' },
  { value: 'shipment', label: 'Remessa entre unidades' },
];

export const lossEventTypeLabel = (v?: string | null) =>
  LOSS_EVENT_TYPES.find(t => t.value === v)?.label || v || '—';

export const clinicalContextTypeLabel = (v?: string | null) =>
  CLINICAL_CONTEXT_TYPES.find(t => t.value === v)?.label || v || '—';

export const isLossMovement = (movementType?: string | null) =>
  ['loss', 'expired'].includes(String(movementType || ''));

/* ── Conciliação de consignado (Fase 2e) ────────────────────────────── */

export const CONSIGNED_SETTLEMENT_STATUSES = [
  { value: 'pending_notice', label: 'Aguardando aviso', color: '#b45309', bg: '#fef3c7' },
  { value: 'pending_invoice', label: 'Aguardando faturamento', color: '#dc2626', bg: '#fee2e2' },
  { value: 'invoiced', label: 'Faturado', color: '#059669', bg: '#d1fae5' },
  { value: 'returned', label: 'Devolvido', color: '#64748b', bg: '#f1f5f9' },
  { value: 'replenished', label: 'Reposição solicitada', color: '#0D9488', bg: '#ccfbf1' },
  { value: 'waived', label: 'Baixado / isento', color: '#6b7280', bg: '#f3f4f6' },
];

export const consignedSettlementStatusInfo = (v?: string | null) =>
  CONSIGNED_SETTLEMENT_STATUSES.find(s => s.value === v) || CONSIGNED_SETTLEMENT_STATUSES[1];

export const CONSIGNED_SETTLEMENT_TYPES = [
  { value: 'consumed', label: 'Consumido / implantado' },
  { value: 'returned', label: 'Devolvido ao fornecedor' },
  { value: 'lost', label: 'Perda / vencimento' },
];

export const consignedSettlementTypeLabel = (v?: string | null) =>
  CONSIGNED_SETTLEMENT_TYPES.find(t => t.value === v)?.label || v || '—';

/* ── Remessas entre unidades (Fase 3) ───────────────────────────────── */

export const SHIPMENT_STATUSES = [
  { value: 'draft', label: 'Rascunho', color: '#64748b', bg: '#f1f5f9' },
  { value: 'in_transit', label: 'Em trânsito', color: '#0D9488', bg: '#ccfbf1' },
  { value: 'receiving', label: 'Em conferência', color: '#b45309', bg: '#fef3c7' },
  { value: 'closed', label: 'Encerrada', color: '#059669', bg: '#d1fae5' },
  { value: 'cancelled', label: 'Cancelada', color: '#dc2626', bg: '#fef2f2' },
];

export const shipmentStatusInfo = (v?: string | null) =>
  SHIPMENT_STATUSES.find(s => s.value === v) || SHIPMENT_STATUSES[0];

export const SHIPMENT_CONFERENCE_STATUSES = [
  { value: 'pending', label: 'Pendente', color: '#64748b', bg: '#f1f5f9' },
  { value: 'received', label: 'Recebido', color: '#059669', bg: '#d1fae5' },
  { value: 'partial', label: 'Parcial', color: '#b45309', bg: '#fef3c7' },
  { value: 'divergent', label: 'Divergente', color: '#dc2626', bg: '#fef2f2' },
  { value: 'cancelled', label: 'Cancelado', color: '#6b7280', bg: '#f3f4f6' },
];

export const shipmentConferenceStatusInfo = (v?: string | null) =>
  SHIPMENT_CONFERENCE_STATUSES.find(s => s.value === v) || SHIPMENT_CONFERENCE_STATUSES[0];

/* ── Itens companheiros (consumo automático) ─────────────────────────── */

export const COMPANION_TRIGGER_OPTIONS = [
  { value: 'out', label: 'Saída manual / baixa' },
  { value: 'procedure', label: 'Execução de procedimento' },
  { value: 'evolution', label: 'Evolução clínica' },
  { value: 'reservation_consume', label: 'Consumo de reserva' },
];

export const companionTriggerLabel = (v?: string | null) =>
  COMPANION_TRIGGER_OPTIONS.find(t => t.value === v)?.label || v || '—';

/* ── Checklist de rastreabilidade (Fase 2d) ─────────────────────────── */

type TraceabilityCheckDef = {
  key: 'patient_identity' | 'medical_record' | 'billing_account' | 'lot_label';
  label: string;
  /** Sempre exigido em item rastreável. */
  always?: boolean;
  /** Exigido apenas quando a linha tem lote. */
  whenBatch?: boolean;
};

export const TRACEABILITY_CHECKS: readonly TraceabilityCheckDef[] = [
  { key: 'patient_identity', label: 'Etiqueta confere com o paciente', always: true },
  { key: 'medical_record', label: 'Prontuário / registro clínico conferido', always: true },
  { key: 'billing_account', label: 'Conta / faturamento conferido', always: true },
  { key: 'lot_label', label: 'Lote e código individual conferidos', whenBatch: true },
];

export type TraceabilityChecks = Partial<Record<typeof TRACEABILITY_CHECKS[number]['key'], boolean>>;

export const validateTraceabilityLines = (
  lines: Array<{
    item_name?: string | null;
    requires_traceability?: boolean;
    batch_id?: string | null;
    lot_number?: string | null;
    traceability_checks?: TraceabilityChecks;
  }>,
): string | null => {
  for (const line of lines) {
    if (!line.requires_traceability) continue;
    const label = line.item_name || 'material rastreável';
    const checks = line.traceability_checks;
    if (!checks?.patient_identity || !checks?.medical_record || !checks?.billing_account) {
      return `Confirme o checklist de rastreabilidade para ${label}.`;
    }
    if ((line.batch_id || line.lot_number) && !checks?.lot_label) {
      return `Confirme lote e código individual para ${label}.`;
    }
  }
  return null;
};

export const getTypeInfo = (t: string) => MOVEMENT_TYPES.find(m => m.value === t) || { label: t, color: '#6b7280' };

export const INVENTORY_UNITS = [
  { value: 'unidade', label: 'Unidade' }, { value: 'caixa', label: 'Caixa' },
  { value: 'pacote', label: 'Pacote' }, { value: 'litro', label: 'Litro' },
  { value: 'kg', label: 'Kg' }, { value: 'ml', label: 'ml' },
  { value: 'mg', label: 'mg' }, { value: 'g', label: 'g' },
  { value: 'par', label: 'Par' }, { value: 'rolo', label: 'Rolo' },
  { value: 'frasco', label: 'Frasco' }, { value: 'ampola', label: 'Ampola' },
  { value: 'comprimido', label: 'Comprimido' }, { value: 'conjunto', label: 'Conjunto' },
  { value: 'seringa', label: 'Seringa' },
];

/* ── Propriedade e estado do lote ────────────────────────────────────── */

export const OWNERSHIP_OPTIONS = [
  { value: 'own', label: 'Próprio (comprado)' },
  { value: 'consigned', label: 'Consignado (do fornecedor)' },
];

export const ownershipLabel = (v?: string | null) =>
  OWNERSHIP_OPTIONS.find(o => o.value === v)?.label || 'Próprio (comprado)';

/** Rótulo curto, para chip de tabela. */
export const ownershipShortLabel = (v?: string | null) =>
  (v === 'consigned' ? 'Consignado' : 'Próprio');

export const BATCH_STATUS_OPTIONS = [
  { value: 'available', label: 'Disponível', color: '#059669', bg: '#d1fae5' },
  { value: 'quarantine', label: 'Quarentena', color: '#b45309', bg: '#fef3c7' },
  { value: 'blocked', label: 'Bloqueado', color: '#6b7280', bg: '#f3f4f6' },
  { value: 'recalled', label: 'Recall', color: '#dc2626', bg: '#fee2e2' },
];

export const batchStatusInfo = (v?: string | null) =>
  BATCH_STATUS_OPTIONS.find(o => o.value === v) || BATCH_STATUS_OPTIONS[0];

/** Só lote disponível sai para consumo — a regra é validada também no backend. */
export const isBatchConsumable = (batch?: { status?: string | null } | null) =>
  !batch?.status || batch.status === 'available';

/* ── Estratégia de abastecimento e catálogo fornecedor ───────────────── */

export const SUPPLY_STRATEGIES = [
  { value: 'regular', label: 'Estoque regular', hint: 'Repor quando atingir o mínimo' },
  { value: 'prefer_consigned', label: 'Preferencialmente consignado', hint: 'Entrada consignada quando possível' },
  { value: 'on_demand', label: 'Sob pedido', hint: 'Não mantém estoque de segurança' },
  { value: 'do_not_reorder', label: 'Não recomprar', hint: 'Item em descontinuação ou uso pontual' },
];

export const supplyStrategyLabel = (v?: string | null) =>
  SUPPLY_STRATEGIES.find(s => s.value === v)?.label || 'Estoque regular';

export const CATALOG_AVAILABILITY_OPTIONS = [
  { value: 'available', label: 'Disponível' },
  { value: 'on_order', label: 'Sob encomenda' },
  { value: 'seasonal', label: 'Sazonal' },
  { value: 'discontinued', label: 'Descontinuado' },
];

export const catalogAvailabilityLabel = (v?: string | null) =>
  CATALOG_AVAILABILITY_OPTIONS.find(o => o.value === v)?.label || v || '—';

/* ── Atributos configuráveis de produto ─────────────────────────────── */

export const ATTRIBUTE_FIELD_TYPES = [
  { value: 'text', label: 'Texto' },
  { value: 'number', label: 'Número' },
  { value: 'select', label: 'Lista de opções' },
  { value: 'boolean', label: 'Sim / Não' },
  { value: 'date', label: 'Data' },
];

export const ATTRIBUTE_ITEM_TYPES = [
  { value: 'geral', label: 'Geral' },
  { value: 'produto', label: 'Produto' },
  { value: 'material', label: 'Material' },
  { value: 'medicamento', label: 'Medicamento' },
];

export const attributeFieldTypeLabel = (t: string) =>
  ATTRIBUTE_FIELD_TYPES.find(f => f.value === t)?.label || t;

export const attributeItemTypeLabel = (t?: string | null) =>
  ATTRIBUTE_ITEM_TYPES.find(i => i.value === t)?.label || t || '';

/** Descreve em uma linha onde um campo declarado aparece. */
export const attributeScopeLabel = (categoryName?: string | null, itemType?: string | null) => {
  const parts: string[] = [];
  if (categoryName) parts.push(categoryName);
  if (itemType) parts.push(attributeItemTypeLabel(itemType));
  return parts.length ? parts.join(' · ') : 'Todos os produtos';
};

export type InventoryAttributeDefinition = {
  id: string;
  attribute_key: string;
  label: string;
  help_text?: string | null;
  field_type: string;
  options?: string[] | null;
  unit_suffix?: string | null;
  is_required?: boolean;
  show_in_list?: boolean;
  is_variant_axis?: boolean;
  min_value?: number | null;
  max_value?: number | null;
  step_value?: number | null;
  sort_order?: number;
};

/** Valor de atributo formatado para leitura (tabela, resumo). */
export const formatAttributeValue = (def: InventoryAttributeDefinition, value: any) => {
  if (value == null || value === '') return '—';
  if (def.field_type === 'boolean') return value ? 'Sim' : 'Não';
  if (def.field_type === 'date') return formatDate(String(value).slice(0, 10));
  return `${value}${def.unit_suffix ? ` ${def.unit_suffix}` : ''}`;
};

/** Movimentações originadas em outro módulo só se desfazem na origem. */
const LINKED_REFERENCE_TYPES = ['appointment', 'procedure', 'execution', 'procedure_execution', 'procedure_undo'];

export type MovementLike = {
  movement_type?: string;
  reference_type?: string | null;
  reversed_at?: string | null;
  reversed_by_movement_id?: string | null;
  reversal_of_movement_id?: string | null;
};

export const isReversedMovement = (mov: MovementLike) =>
  Boolean(mov.reversed_at || mov.reversed_by_movement_id);

export const isReversalMovement = (mov: MovementLike) => Boolean(mov.reversal_of_movement_id);

export const isLinkedMovement = (mov: MovementLike) =>
  LINKED_REFERENCE_TYPES.includes(String(mov.reference_type || ''));

/** Estorno é o único caminho de correção, e vale uma vez por lançamento. */
export const canReverseMovement = (mov: MovementLike) =>
  !isReversedMovement(mov) && !isReversalMovement(mov) && !isLinkedMovement(mov);

export const formatDate = (d: string) => d ? new Date(d + (d.length === 10 ? 'T12:00:00' : '')).toLocaleDateString('pt-BR') : '-';

export const formatDateTime = (d: string) => d ? new Date(d).toLocaleString('pt-BR') : '-';

export const formatCurrency = (v: number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

export const formatQtySigned = (mov: { movement_type: string; quantity: number }, unit = 'unidade') => {
  const qty = Number(mov.quantity);
  const isIn = ['in', 'return'].includes(mov.movement_type);
  const isOut = ['out', 'loss', 'expired'].includes(mov.movement_type);
  const sign = isIn ? '+' : isOut ? '-' : '';
  const color = isIn ? '#10b981' : isOut ? '#ef4444' : '#64748b';
  return { text: `${sign}${qty} ${unit}`, color };
};

export type BatchLine = { lot_number?: string | null; expiration_date?: string | null; quantity: number };

export type BatchSummary = {
  batch_count: number;
  batches: BatchLine[];
  nearest_expiration?: string | null;
  has_expired?: boolean;
  has_expiring_soon?: boolean;
};

export const isExpiredDate = (d?: string | null) => {
  if (!d) return false;
  const exp = new Date(d.length === 10 ? `${d}T12:00:00` : d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return exp < today;
};

export const isExpiringSoonDate = (d?: string | null, days = 30) => {
  if (!d || isExpiredDate(d)) return false;
  const exp = new Date(d.length === 10 ? `${d}T12:00:00` : d);
  const limit = new Date();
  limit.setDate(limit.getDate() + days);
  return exp <= limit;
};

export const resolveExpiryWarningDays = (raw?: unknown, fallback = 30): number => {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? Math.min(3650, Math.floor(n)) : fallback;
};

export const expiryTone = (
  d?: string | null,
  warningDays = 30,
): 'expired' | 'soon' | 'ok' | 'none' => {
  if (!d) return 'none';
  if (isExpiredDate(d)) return 'expired';
  if (isExpiringSoonDate(d, warningDays)) return 'soon';
  return 'ok';
};

export const expiryColor = (d?: string | null, warningDays = 30) => {
  const tone = expiryTone(d, warningDays);
  if (tone === 'expired') return '#b91c1c';
  if (tone === 'soon') return '#b45309';
  if (tone === 'ok') return '#64748b';
  return '#cbd5e1';
};

export const formatBatchLine = (b: BatchLine, unit = 'un') => {
  const datePart = b.expiration_date ? formatDate(b.expiration_date) : 's/ validade';
  const lotPart = b.lot_number ? `Lote ${b.lot_number} · ` : '';
  return `${lotPart}${datePart} (${b.quantity} ${unit})`;
};
